// extracted by mini-css-extract-plugin
module.exports = {"card":"RateDistribution_card__9kKYE","rateModifierFormItemsTitle":"RateDistribution_rateModifierFormItemsTitle__79zBP","pricePreview":"RateDistribution_pricePreview__2YOyh"};